import React from 'react'

const ENV_PROPERTIES_BASE_URL = '/services/plugin-env-properties'

export const listEnvProperties = async (): Promise<unknown> => {

    return fetch(`${ENV_PROPERTIES_BASE_URL}/env/property/`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {


            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}

export const putEnvProperties = async (object: unknown): Promise<unknown> => {
    return fetch(`${ENV_PROPERTIES_BASE_URL}/env/property/all`, {
        method: 'PUT',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(object)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
